<script>

    import { toast } from 'bulma-toast'
    import { modalStore, providersStore } from '../stores'

    import ProvidersService from '../$services/providers.service'

    import Form from '../$components/form.svelte'
    import InputNumber from '../$components/input.number.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import Button from '../$components/button.svelte'
    import Data from '../$components/data.svelte'

    import SelectProviders from '../$components/select.providers.svelte'
    import SelectServices from '../$components/select.services.svelte'
    import Select from '../$components/select.svelte'
    import Icon from '../$components/icon.svelte'

    export let showCancel = true
    export let showTitle = true

    let loading = false
    
    let item = {}
    let data = {
        coverageCost: 0,
        coverageSpecial: 0,
        services: []
    }

    async function createProvider() {

        loading = true
        const resp = await ProvidersService.createProvider(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        providersStore.append(resp.data)
        toast({message: 'Proveedor creado', type: 'is-success'})

        modalStore.close()
    }

    function addService() {

        if(!item.name)
            return

        if(data.services.find(service => service.name == item.name))
            return

        data.services = [...data.services, {...item}]
    }

    function removeService(index) {
        data.services = data.services.filter((service, i) => i != index)
    }

</script>

{#if showTitle}
    <div class="subtitle is-5">Crear proveedor</div>
{/if}

<Form on:submit={createProvider} { loading }>

    <SelectProviders bind:provider={data.name} on:change={() => data.services = []} />

    {#if data.name != 'Partner'}

        <div class="subtitle is-5">Servicios</div>
        <hr>

        {#each data.services as service, index}
            <div class="columns">
                <div class="column is-1 is-flex is-justify-content-center is-align-items-center">
                    <Icon on:click={() => removeService(index)} icon="ban" />
                </div>
                <div class="column is-3">
                    <Data name="Servicio" value={ service.name } />
                </div>
                <div class="column is-3">
                    <Data name="Precio" value={ service.setPrice  } />
                </div>
                {#if service.setPrice === 'percent'}
                    <div class="column is-3">
                        <Data name="Porcentaje" value={ service.percent } />
                    </div>
                    <div class="column is-2">
                        <Data name="IVA" value={ service.iva } />
                    </div>
                {/if}
                {#if service.setPrice === 'flat'}
                    <div class="column is-2">
                        <Data name="Peso referencia" value={ service.weightControl } />
                    </div>
                    <div class="column is-2">
                        <Data name="Precio base" value={ service.shipmentPrice } />
                    </div>
                    <div class="column is-2">
                        <Data name="Costo por kilo" value={ service.weightCost } />
                    </div>
                {/if}
            </div>
        {/each}
        <hr>

        <SelectServices bind:service={item.name} bind:provider={ data.name } />

        <Select
            bind:value={item.setPrice}
            required={false}
            label="Precio"
            options={[
                {value: 'percent', text: 'Porcentaje'},
                {value: 'pricing', text: 'Pricing'},
                {value: 'flat', text: 'Flat'},
            ]}
        />

        {#if item.setPrice === 'percent'}
            <div class="columns">
                <div class="column">
                    <InputNumber bind:value={item.percent} label="Porcentaje" placeholder="Porcentaje" />
                </div>
                <div class="column">
                    <InputNumber bind:value={item.iva} label="IVA" placeholder="IVA" />
                </div>
            </div>
        {/if}

        {#if item.setPrice === 'flat'}
            <div class="columns">
                <div class="column">
                    <InputNumber bind:value={item.weightControl} label="Peso referencia" placeholder="Peso referencia" />
                </div>
                <div class="column">
                    <InputNumber bind:value={item.shipmentPrice} label="Precio base" placeholder="Precio base" />
                </div>
                <div class="column">
                    <InputNumber bind:value={item.weightCost} label="Costo por kilo" placeholder="Costo por kilo" />
                </div>
            </div>
        {/if}

        <div class="is-flex is-justify-content-flex-end is-align-items-center">
            <Button on:click={addService} text="Agregar" icon="plus" />
        </div>

        <hr>
    {/if}

    {#if data.name === 'Redpack'}
        <div class="columns">
            <div class="column">
                <InputNumber bind:value={data.coverageCost} label="Cobertura con costo" placeholder="Cobertura con costo" />
            </div>
            <div class="column">
                <InputNumber bind:value={data.coverageSpecial} label="Cobertura especial" placeholder="Cobertura especial" />
            </div>
        </div>
    {/if}

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        {#if showCancel}
            <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        {/if}

        <ButtonSave />
    </div>

</Form>